import { CloudDiscoveryKey } from '../../utils/contexts';
import AIEM from '../AdminCenterPage/AIEM';
import AIUnitConsumption from '../AdminCenterPage/AIUnitConsumption';
import AIUnitHourly from '../AdminCenterPage/AIUnitHourly';
import AIUnitWorkspace from '../AdminCenterPage/AIUnitWorkspace';
import AppEvent from '../AdminCenterPage/AppEvent';
import CustomGroupManagement from '../AdminCenterPage/CustomGroupManagement';
import EnvInfo from '../AdminCenterPage/EnvInfo';
import EScorer from '../AdminCenterPage/EScorer';
import FWManagement from '../AdminCenterPage/FWManagement';
import GaugeMetricEvent from '../AdminCenterPage/GaugeMetricEvent';
import H2OGPTe from '../AdminCenterPage/H2OGPTe';
import IdpManagement from '../AdminCenterPage/IdpManagement';
import InstanceEvent from '../AdminCenterPage/InstanceEvent';
import TrustedRoleManagement from '../AdminCenterPage/TrustedRoleManagement';
import UserLogin from '../AdminCenterPage/UserLogin';
import UserManagement from '../AdminCenterPage/UserManagement';
import { RoutePaths } from '../RoutePaths';
import type { RouteDefinition } from './routeDefinitions';

const sharedParams: Partial<RouteDefinition> = {
  exact: true,
  requiresDiscoveryKey: CloudDiscoveryKey.mcAdminCenterApiUrl,
  requiresEnvCondition: (env) => !!env.menu?.adminCenterEnabled,
};

export const ADMIN_CENTER_ROUTE_DEFINITIONS: readonly RouteDefinition[] = [
  // Authenticated routes
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_AI_UNIT_CONSUMPTION,
    requiresAuth: true,
    render: () => <AIUnitConsumption />,
  },

  // Admin routes
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_FW_MANAGEMENT,
    requiresAdmin: true,
    render: () => <FWManagement />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_MEMBER_MANAGEMENT,
    requiresAdmin: true,
    render: () => <UserManagement />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_IDP_MANAGEMENT,
    requiresAdmin: true,
    render: () => <IdpManagement />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_ENV_INFO,
    requiresAdmin: true,
    render: () => <EnvInfo />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_USER_LOGIN,
    requiresAdmin: true,
    render: () => <UserLogin />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_AIEM,
    requiresAdmin: true,
    render: () => <AIEM />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_AI_UNIT_HOURLY,
    requiresAdmin: true,
    render: () => <AIUnitHourly />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_AI_UNIT_WORKSPACE,
    requiresAdmin: true,
    render: () => <AIUnitWorkspace />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_APP_EVENT,
    requiresAdmin: true,
    render: () => <AppEvent />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_INSTANCE_EVENT,
    requiresAdmin: true,
    render: () => <InstanceEvent />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_MLOPS,
    requiresAdmin: true,
    render: () => <GaugeMetricEvent />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_H2O_GPTE,
    requiresAdmin: true,
    render: () => <H2OGPTe />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_ESCORER,
    requiresAdmin: true,
    render: () => <EScorer />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_CUSTOM_GROUPS,
    requiresAdmin: true,
    render: () => <CustomGroupManagement />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ADMIN_CENTER_TRUSTED_ROLES,
    exact: true,
    requiresAdmin: true,
    render: () => <TrustedRoleManagement />,
  },
];
